module.exports = __webpack_public_path__ + "fonts/Inter-Italic.e4ad366.woff";